import React from 'react';

import ModalContainer from '../ModalContainer';
import Partner from 'app/pages/Catalog/components/Partner';
import { LoadingContainer } from '../LoadingContainer';

interface PartnerModalProps {
  open: boolean;
  onChange: (value: Record<string, any>) => void;
  onClose: () => void;
  onProceedToBookTicket: (bpAllocatedDebt: string | number) => void;
  loading?: boolean;
}

const PartnerModal: React.FC<PartnerModalProps> = props => {
  const { open, onChange, onClose, onProceedToBookTicket, loading } = props;

  return (
    <ModalContainer
      isShow={open}
      onCloseDialog={onClose}
      styleSlots={{
        modalContentStyle: {
          width: '90vw',
          maxWidth: '600px',
          height: 'auto',
          padding: '24px 30px',
        },
        iconWrapperStyle: {
          margin: 0,
          transform: 'scale(0.8)',
          position: 'relative',
          top: 10,
          right: 13,
        },
      }}
      maskClosable={false}
      modalProps={{
        destroyOnClose: true,
      }}
    >
      <LoadingContainer loading={loading} minHeight="initial">
        <Partner
          onProceedToBookTicket={onProceedToBookTicket}
          onChange={onChange}
        />
      </LoadingContainer>
    </ModalContainer>
  );
};

export default PartnerModal;
